<div>
  <label *ngIf="label">{{ label }}</label>

  <div class="uploader-container" [class.uploader-container--compact]="compact" [attr.aria-busy]="processing">
    <label
      class="file-uploader"
      [class.file-uploader--disabled]="disabled || processing"
      [nbSpinner]="processing"
      [nbSpinnerMessage]="processingMessage"
      nbSpinnerSize="small"
    >
      <span class="placeholder" [style.visibility]="processing ? 'hidden' : 'visible'">
        <img src="assets/images/upload-file.png" class="placeholder-img" />
        <span class="placeholder-text">
          <span>برای بارگذاری فایل کلیک کنید</span>
          <span class="seperator">یا</span>
          <span>فایل مدنظر را اینجا بکشید</span>
        </span>
      </span>

      <input
        #fileInput
        type="file"
        [accept]="accept"
        [multiple]="multiple"
        [disabled]="disabled || processing"
        (change)="onFileSelected($event)"
      />
    </label>

    <span class="invalid-file-message" role="alert" *ngIf="invalidFileMessage">
      {{ invalidFileMessage }}
    </span>

    <!-- FILE LIST -->
    <div class="file-list" *ngIf="fileItems.length">
      <div class="file-item" *ngFor="let item of fileItems; let i = index">
        <span class="preview">
          <img
            *ngIf="item.fileUrl && getFileKind(item) === 'image'"
            [src]="item.fileUrl"
            [alt]="item.fileName"
          />

          <span
            *ngIf="getFileKind(item) !== 'image'"
            class="preview-icon"
          >
            <nb-icon [icon]="getFileKind(item) === 'pdf' ? 'file-text-outline' : getFileKind(item) === 'audio' ? 'mic-outline' : getFileKind(item) === 'video' ? 'film-outline' : 'file-outline'"></nb-icon>
          </span>
        </span>

        <div class="detail">
          <span class="name">{{ item.fileName }}</span>
          <span class="size" *ngIf="item.fileSize">{{ item.fileSize }}</span>
          <span class="compression-result" *ngIf="item.originalFileSize">
            حجم اولیه {{ item.originalFileSize }} · {{ item.sizeReductionPercent }}٪ کاهش حجم
          </span>
          <audio *ngIf="item.fileUrl && getFileKind(item) === 'audio'" controls preload="none" [src]="item.fileUrl">
            مرورگر شما پخش صوت را پشتیبانی نمی‌کند.
          </audio>
        </div>

        <div class="actions">
          <button
            type="button"
            class="btn see"
            *ngIf="item.fileUrl && getFileKind(item) === 'pdf'"
            (click)="openPdf(item)"
            aria-label="باز کردن سند PDF"
          >
            <nb-icon icon="external-link-outline"></nb-icon>
          </button>
          <button
            type="button"
            class="btn see"
            *ngIf="item.fileUrl && (getFileKind(item) === 'image' || getFileKind(item) === 'video')"
            (click)="handleSeeFile(imageDialog, item)"
            aria-label="پیش‌نمایش فایل"
          >
            <nb-icon icon="eye-outline"></nb-icon>
          </button>

          <button type="button" class="btn delete" [disabled]="disabled || processing" (click)="handleDeleteFile(i)" aria-label="حذف فایل">
            <nb-icon icon="trash-outline"></nb-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- IMAGE PREVIEW DIALOG -->
<ng-template #imageDialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>پیش‌نمایش فایل</nb-card-header>
    <nb-card-body>
      <img
        *ngIf="!data.fileType || data.fileType?.includes('image')"
        [src]="data?.fileUrl"
        class="dialog-image"
      />
      <video
        controls
        *ngIf="data.fileType && data.fileType?.includes('video')"
        [src]="data?.fileUrl"
        class="dialog-video"
      >
        <source [src]="data?.fileUrl" />
      </video>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton status="basic" (click)="ref.close()">بستن</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
